import { Center, Loader } from '@mantine/core';
import { useEffect, ReactNode } from 'react';
import { useLocation } from 'wouter';

import { useAdminAuthStore } from '../stores/useAdminAuthStore';

interface AdminAuthGuardProps {
	children: ReactNode;
}

/**
 * Auth guard component that protects admin routes
 * Redirects to login page if user is not authenticated
 */
export default function AdminAuthGuard({ children }: AdminAuthGuardProps) {
	const [, setLocation] = useLocation();
	const { isAuthenticated, isInitialized, initialize } = useAdminAuthStore();

	useEffect(() => {
		initialize();
	}, [initialize]);

	useEffect(() => {
		if (isInitialized && !isAuthenticated) {
			setLocation('/login');
		}
	}, [isInitialized, isAuthenticated, setLocation]);

	// Show loader while initializing
	if (!isInitialized) {
		return (
			<Center style={{ minHeight: '100vh' }}>
				<Loader size="xl" />
			</Center>
		);
	}

	// Don't render children until authenticated
	if (!isAuthenticated) {
		return null;
	}

	return <>{children}</>;
}
